// extracted by mini-css-extract-plugin
export default {"Dialog":"CheckStatusDialog-module__Dialog--TK4Dm","Dialog_Body":"CheckStatusDialog-module__Dialog_Body--WjYUz","Box":"CheckStatusDialog-module__Box--KtBxw"};